import { render } from "./OrderInquiry.vue?vue&type=template&id=35a6b1d6"
import script from "./OrderInquiry.vue?vue&type=script&lang=js"
export * from "./OrderInquiry.vue?vue&type=script&lang=js"

import "./OrderInquiry.vue?vue&type=style&index=0&id=35a6b1d6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__